__turbopack_context__.v({
  "offer-hero": "OfferHeroView-module-scss-module__ulHouG__offer-hero",
  "title": "OfferHeroView-module-scss-module__ulHouG__title",
});
